module.exports = __webpack_public_path__ + "static/media/explore-1b.233cd598.jpeg";